<template>
  <div class="new-automation-modal-body">
    <FormInputGroup label="Automation name" for-id="automation-name">
      <FormInput
        id="automation-name"
        ref="inputRef"
        :value="modelValue"
        type="text"
        placeholder="e.g. Weekly status update"
        state="default"
        @update:value="(value: string) => $emit('update:modelValue', value)"
        @keydown="onKeydown"
      />
    </FormInputGroup>
    <FormInputGroup
      v-if="showAgentSelector"
      label="Agent"
      for-id="automation-agent"
    >
      <BaseInputSelect
        :value="agentValue"
        :options="agentOptionsWithNone"
        :disabled="agentOptions.length === 0"
        placeholder="No agent"
        select-only
        size="form"
        @update:value="(value: string) => $emit('update:agentValue', value)"
      />
    </FormInputGroup>
  </div>
</template>

<script lang="ts">
import type { PropType } from "vue";
import { computed, defineComponent, onMounted, ref } from "vue";

import BaseInputSelect, {
  type SelectOption,
} from "@/components/base/BaseInputSelect.vue";
import FormInput from "@/components/graph/definition/form/FormInput.vue";
import FormInputGroup from "@/components/graph/definition/form/FormInputGroup.vue";

export default defineComponent({
  name: "NewAutomationModalBody",
  components: { BaseInputSelect, FormInput, FormInputGroup },
  props: {
    modelValue: { type: String, required: true },
    agentValue: { type: String, default: "" },
    agentOptions: {
      type: Array as PropType<SelectOption[]>,
      default: () => [],
    },
    showAgentSelector: { type: Boolean, default: false },
  },
  emits: {
    "update:modelValue": (_value: string) => true,
    "update:agentValue": (_value: string) => true,
    submit: () => true,
  },
  setup(props, { emit }) {
    const inputRef = ref<InstanceType<typeof FormInput>>();

    onMounted(() => {
      inputRef.value?.focus();
    });

    const agentOptionsWithNone = computed<SelectOption[]>(() => [
      { value: "", label: "No agent", aliases: [], separatorAfter: true },
      ...props.agentOptions,
    ]);

    const onKeydown = (event: KeyboardEvent) => {
      if (event.key === "Enter") {
        emit("submit");
      }
    };

    return { agentOptionsWithNone, inputRef, onKeydown };
  },
});
</script>

<style scoped lang="scss">
.new-automation-modal-body {
  display: flex;
  flex-direction: column;
  row-gap: 12px;
}
</style>
